export const useSxStyles = () => {
  return {
    boxStyles: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      '& p': {
        flexBasis: '50%',
      },
    },
    navItem: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textDecoration: 'none',
      fontSize: '20px',
      lineHeight: 1,
      width: '50px',
      border: 'none',
      cursor: 'pointer',
    },
  };
};
